export default __webpack_public_path__ + "static/media/lampshade-new.9f9c6973.jpg";